// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Airlines-module__wrapper___CwWw-"};